import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import MPartnerCard from '../molecules/_molecules.partner-card';

export default function OPartners({ items }) {
	return (
		<section className="o-section-partners">
			{
				items.map((item) => {
					return (<MPartnerCard
						key={get(item, 'name', '')}
						{...item}
					/>);
				})
			}
		</section>
	);
}

OPartners.propTypes = {
	items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.partners.js